import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'

import { PieChart, Pie, Cell, Legend, Label, Text, ResponsiveContainer } from 'recharts'

import {
  _ChartWrapper, _LegendItemCopy,
} from './styles.js'

export const PIE_RADIUS = 67

export const getPopulationPieColors = (isCondos) => (
  isCondos ? {
    pieOne: '#0097A7',
    pieTwo: '#075762',
    pieThree: '#CF5CB6',
    pieFour: '#90D4D4',
    pieFive: '#35BAC8',
    pieSix: '#900772',
  } : {
    pieOne: '#07364B',
    pieTwo: '#018484',
    pieThree: '#E8194B',
    pieFour: '#25BEBE',
    pieFive: '#5E7387',
    pieSix: '#186685',
  }
)


const PieGraph = ({
  desktopView, xsView, groupArrays,
  centerTitle, centerValue, groupHash,
  height,
}) => {
  const pieRadius = xsView ? 57 : PIE_RADIUS

  const [pieProps, setPieProps] = useState(
    groupArrays.reduce(
      (a, { variable }) => {
        a[variable] = false // eslint-disable-line
        return a
      },
      { hover: null },
    ),
  )
  const handleLegendMouseEnter = e => {
    if(!pieProps[e.value]) {
      setPieProps({ ...pieProps, hover: e.value })
    }
  }

  const handleLegendMouseLeave = () => {
    setPieProps({ ...pieProps, hover: null })
  }

  return (
    <_ChartWrapper>
      <ResponsiveContainer width="95%" height={height}>
        <PieChart
          // width={690}
          // width="100%"
          // height={400}
          height={desktopView ? 160 : 260}
          margin={{
            top: 0, right: 0, bottom: 0, left: 0,
          }}
        >
          <Pie
            data={groupArrays}
            dataKey="value"
            nameKey="variable"
            cx={pieRadius}
            cy={desktopView ? '50%' : pieRadius + 15}
            innerRadius={pieRadius - 20}
            outerRadius={pieRadius}
            fill="#82ca9d"
            blendStroke
          >
            {
              groupArrays.map(entry => (
                <Cell
                  fill={groupHash[entry.variable]?.color}
                  hide={pieProps[entry.key] === true}
                  fillOpacity={
                    pieProps.hover === entry.variable || !pieProps.hover ?
                      1 : 0.2
                  }
                  strokeOpacity={0}
                  key={entry.label}
                />
              ))
            }
            <Label
              // eslint-disable-next-line react/no-unstable-nested-components
              content={({ viewBox: { cx, cy } }) => {
                const positioningProps = {
                  x: cx,
                  y: cy,
                  textAnchor: 'middle',
                  verticalAnchor: 'middle',
                }

                return (
                  <Fragment>
                    <Text
                      {...positioningProps}
                      fill="#707070"
                      style={{ fontSize: '12px' }}
                      y={cy - 5}
                    >
                      {centerTitle}
                    </Text>

                    <Text
                      {...positioningProps}
                      style={{ fontSize: '16px' }}
                      y={cy + 15}
                    >
                      {centerValue}
                    </Text>
                  </Fragment>
                )
              }}
            />
          </Pie>

          <Legend
            // width={500}
            iconType="square"
            formatter={
              // eslint-disable-next-line react/no-unstable-nested-components
              (value, entry) => (
                entry && entry.payload && groupHash[value] ?
                  <_LegendItemCopy key={value}>
                    {Math.round(entry.payload.value * 100)}%
                    <span>({groupHash[value][desktopView ? 'label' : 'mobileLabel']})</span>
                  </_LegendItemCopy>
                  : '')
            }
            align="right"
            layout="vertical"
            verticalAlign={desktopView ? 'middle' : 'top'}
            onMouseOver={handleLegendMouseEnter}
            onMouseOut={handleLegendMouseLeave}
          />
        </PieChart>
      </ResponsiveContainer>
    </_ChartWrapper>
  )
}


PieGraph.propTypes = {
  desktopView: PropTypes.bool,
  xsView: PropTypes.bool,
  groupArrays: PropTypes.arrayOf(PropTypes.shape({})),

  centerTitle: PropTypes.string,
  centerValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.number,
  groupHash: PropTypes.shape({}),
}

export default PieGraph
